__turbopack_context__.v({
  "carouselContainer": "InstagramCarouselBlock-module__m9JrTW__carouselContainer",
});
